export default __webpack_public_path__ + "static/media/carousel-3-simple-rewards-fractal-v4.a15fbd87.png";